export default {
  ENVELOPE_CONFIG: 'envelope-config',
  GET_FILES_ITEM: 'get-files-item',

  GET_SIGNER_DATA: 'get-signer-data',
  GET_DOCUMENT_HISTORY: 'get-document-history',
  GET_MANUAL_RECIPIENTS: 'manual-recipients',

  MONDAY_ITEM_NAME: 'monday-item-name',
  MONDAY_GET_SESSION_TOKEN: 'session-token',
  MONDAY_GET_COLUMN_VALUES: 'column-values',
  MONDAY_GET_ITEM_DETAILS: 'get-item-details',
  MONDAY_GET_BOARD_COLUMNS: 'get-board-columns',
  MONDAY_GET_SUBSCRIPTION_STATUS: 'get-subscription-status',
  MONDAY_GET_CONTEXT: 'get-context',
  MONDAY_GET_VALUE_FROM_STORAGE: 'get-value-from-storage',
  MONDAY_GET_BOARD_PERMISSION: 'get-board-permission',
  MONDAY_GET_BOARD_SUBSCRIBERS: 'get-board-subscribers',
  GENERATE_SIGNING_LINK: 'generate-signing-link',
  COPY_SIGNING_LINK: 'copy-signing-link',
  GET_PROGRESS_STATUS: 'get-progress-status',

  GET_USAGE_STATS: 'get-usage-stats',

  GET_LOGO: 'get-logo',

  GET_TEMPLATE_GALLERY: 'get-templates-template-gallery',
  TEMPLATE_GALLERY_USER_TEMPLATES: 'template-gallery-user-templates',

  CHECK_GENERATION_STATUS: 'check-generation-status',
  GET_DOMAIN: 'get-domain',
  GET_USER_ONBOARDING: 'get-user-onboarding',
};
